module.exports = {
      id: "linkedin-circle-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-61dfca8afc3dd3934ecf034e99eaf2c3.svg#linkedin-circle-color",
      toString: function () {
        return this.url;
      }
    }